<div id="main-wrapper" class="min-vh-100 d-flex align-items-center justify-content-center">
  <div class="row h-100 w-100">
    <!-- <div class="col-lg-6 d-lg-flex align-items-center justify-content-center login-set-bg pe-0">
      <div class="login-content">
        <h2>Specialists in R&D Tax and other innovation incentives</h2>
        <p>
          The UK Government has committed to raising investment in Research and
          Development (R&D) to 2.4% of Gross Domestic Product (GDP) by 2027. To
          further this objective, generous tax relief and grant funding schemes
          are available for companies undertaking research and development.
        </p>
        <p>
          iTax Advisors Limited is a specialist innovation tax consultancy
          focused solely on assisting UK companies in harnessing these
          government incentives.
        </p>
        <div class="video-btn">
          <button class="btn btn-primary">
            <span>Video</span>
            <img src="../../../assets/Krid/img/video-icon.svg" alt="" />
          </button>
        </div>
      </div>
    </div> -->
    <div class="col-lg-12 px-0">
      <div class="pattern-design d-flex align-items-center justify-content-center">
        <div class="row d-flex flex-column justify-content-center">
          <div class="col-lg-12 col-12 m-auto d-flex justify-content-center">
            <div class="p-3">
              <div class="mb-4 mt-3 mt-lg-0">
                <img src="../../../assets/Krid/img/main-logo.svg" class="m-auto d-table logo" alt />
              </div>
              <div class="heading" *ngIf="!isLinkValid">
                <h2>Set Password</h2>
                <p >
                  Choose a new password that’s hard to guess and unique to this
                  account.
                </p>
              </div>
              <div class="heading" *ngIf="isLinkValid">
                <h2>Set Password</h2>
                <p >
                  Your create password link has been expired. Please request a new one to set your password.
                </p>
              </div>
              <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassForm()">
                <div>
                  <div class="form-group" *ngIf="!isLinkValid">
                    <label>{{ labelConstants.NewPassword}}<span class="text-danger">*</span></label>
                    <div class="position-relative mb-1">
                      <input oninput="this.value = this.value.replace(/^\s+/g, '')"
                        [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                        formControlName="NewPassword" placeholder="New password" maxlength="16"
                        (focus)="togglePasswordRequirements(true)" (blur)="togglePasswordRequirements(false)"
                        (input)="checkPasswordValidity()" />
                      <i class="fa-regular fa-eye visibility cursor" *ngIf="!showNewPassword"
                        (click)="togglePasswordVisibility('showNewPassword')"></i>
                      <i class="fa-regular fa-eye-slash visibility cursor" *ngIf="showNewPassword"
                        (click)="togglePasswordVisibility('showNewPassword')"></i>
                    </div>
                    <span class="text-danger"
                      *ngIf="submitted && changePassControls['NewPassword'].errors?.['required']">{{
                      errorConstants.NewPassRequired }}</span>
                    <span class="text-danger"
                      *ngIf="submitted && changePassControls['NewPassword'].errors?.['pattern']">{{
                      errorConstants.NewPassInvalid }}</span>
                  </div>
                  <div class="form-group mb-4" *ngIf="!isLinkValid">
                    <label>{{ labelConstants.ConfirmPassword
                      }}<span class="text-danger">*</span></label>
                    <div class="position-relative mb-1">
                      <input oninput="this.value = this.value.replace(/^\s+/g, '')"
                        [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                        formControlName="ConfirmNewPassword" placeholder="Confirm password" maxlength="16" />
                      <i class="fa-regular fa-eye visibility cursor" *ngIf="!showConfirmPassword" (click)="
                          togglePasswordVisibility('showConfirmPassword')
                        "></i>
                      <i class="fa-regular fa-eye-slash visibility cursor" *ngIf="showConfirmPassword" (click)="
                          togglePasswordVisibility('showConfirmPassword')
                        "></i>
                    </div>
                    <span class="text-danger"
                      *ngIf="submitted && changePassControls['ConfirmNewPassword'].errors?.['required']">{{
                      errorConstants.ConfPassRequired }}</span>
                    <span class="text-danger" *ngIf="
                        resetPasswordForm.hasError('mismatch') &&
                        resetPasswordForm.get('ConfirmNewPassword').touched
                      ">
                      {{ errorConstants.PassNotMatch }}
                    </span>
                    <div class="text-center" *ngIf="isLinkValid">
                      <p>{{ labelConstants.expiredLink }}</p>
                    </div>
                  </div>
                  <div class="mt-3">
                    <button *ngIf="!isLinkValid" class="btn login-btn mt-3 mb-3 cursor" type="submit"
                      [disabled]="isLoading" [ngClass]="{ loading: isLoading }">
                      <span *ngIf="!isLoading">{{
                        labelConstants.ResetPassword
                        }}</span>
                      <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    </button>
                  </div>
                  <div class="form-group d-flex align-items-center justify-content-center back-text">
                    <a class="mt-3 mb-3 text-center d-block back-login" type="submit" routerLink="/"><i
                        class="fa-solid fa-arrow-left me-4"></i>{{ labelConstants.BackToLogin }}</a>
                  </div>
                  <div class="rights-content">
                    <label>© {{currentYear}} ALL RIGHTS RESERVED. </label>
                    <span>KRID</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
